import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "LIBRARY/CommonResources/RoutingMenu/routingmenu.css";
import { useDispatch, useSelector } from "react-redux";
import config from "config";
import resource from "../images/Resource.png"
import Periodicals from "../images/Periodicals.png"
import issuereturn from "../images/Issue Return Resource.png"
import Eresources from "../images/e-Resources.png"
import Requisition from "../images/Resource Requisition.png"
import Rules from "../images/Rules.png"
import Dashboard from "../images/Dashboard.png"
import { Base64 } from "js-base64";
// import Status from "../images/Resource Status.png"

const RoutingMenu = (props) => {
    // VARIABLES TO SHOW ROUTING MENU
    const [activeScreen, setActiveScreen] = useState(props.activeScreen);
    const libraryScreens = ['printBarcode', 'stockVerification', 'scannedStatus', 'resourceStatus'];

    //GET TEMPLATE DATA
    const routingMenu = useSelector((state) => state.RouteMenuReducer);

    const dispatch = useDispatch();

    useEffect(() => {
        if (libraryScreens.includes(activeScreen)) {
            dispatch({ type: 'SET_SIDE_MENU_NAVIGATION', sideMenuNavigation: false });
        } else {
            dispatch({ type: 'SET_SIDE_MENU_NAVIGATION', sideMenuNavigation: true });
        }
    }, []);

    const navScreens = [
        {
            name: "Dashboard",
            url: `/dashboard`,
            activeScreen: 'dashboard',
            icon: <img style={{ height: "17px" }} src={Dashboard} />,
            isAccessible: true
        },
        {
            name: "Resource",
            url: `/resourceDetails`,
            activeScreen: 'resourceDetails',
            icon: <img style={{ height: "17px" }} src={resource} />,
            isAccessible: routingMenu.accessibleScreens.includes('resource') || routingMenu.isLibraryAdmin
        },
        {
            name: "Issue / Return Resource",
            url: '/issuereturn',
            activeScreen: 'issueReturnResource',
            icon: <img style={{ height: "17px" }} src={issuereturn} />,
            isAccessible: routingMenu.accessibleScreens.includes('issue/return') || routingMenu.isLibraryAdmin

        },
        {
            name: "Reserve A Book",
            url: '/reserveABookForAdmin',
            activeScreen: 'reserveABookForAdmin',
            icon: <FontAwesomeIcon icon={['fas', 'clipboard-check']} size="lg" />,
            isAccessible: true
        },
        {
            name: "Periodicals",
            url: '/periodicals',
            activeScreen: 'periodicals',
            icon: <img style={{ height: "17px" }} src={Periodicals} />,
            isAccessible: routingMenu.accessibleScreens.includes('periodicals') || routingMenu.isLibraryAdmin

        },
        {
            name: "e-Resources",
            url: '/eresources',
            activeScreen: 'eResources',
            icon: <img style={{ height: "17px" }} src={Eresources} />,
            isAccessible: routingMenu.accessibleScreens.includes('e-resources') || routingMenu.isLibraryAdmin

        },
        // {
        //     name: "Rules",
        //     url: '/rules',
        //     activeScreen: 'rules',
        //     icon: <img style={{ height: "17px" }} src={Rules} />,
        //     isAccessible: routingMenu.accessibleScreens.includes('rules') || routingMenu.isLibraryAdmin

        // },
        {
            name: "Library Entry",
            url: '/libraryentry',
            activeScreen: 'libraryEntry',
            icon: <FontAwesomeIcon icon={['fab', 'readme']} size="lg" />,
            isAccessible: routingMenu.accessibleScreens.includes('library entry') || routingMenu.isLibraryAdmin

        },
        {
            name: "Publisher",
            url: '/publisher',
            activeScreen: 'publisher',
            icon: <FontAwesomeIcon icon={['fas', 'building']} size="lg" />,
            isAccessible: routingMenu.accessibleScreens.includes('publisher') || routingMenu.isLibraryAdmin

        },
        {
            name: "Donor's List",
            url: '/donorlist',
            activeScreen: 'donorList',
            icon: <FontAwesomeIcon icon={['fas', 'user-check']} size="lg" />,
            isAccessible: routingMenu.accessibleScreens.includes('donor list') || routingMenu.isLibraryAdmin

        },
        {
            name: "Print Barcode",
            url: '/printbarcode',
            activeScreen: 'printBarcode',
            icon: <FontAwesomeIcon icon={['fas', 'barcode']} size="lg" />,
            isAccessible: routingMenu.accessibleScreens.includes('print barcode') || routingMenu.isLibraryAdmin

        },
        {
            name: "Stock Verification",
            url: '/stockverification',
            activeScreen: 'stockVerification',
            icon: <FontAwesomeIcon icon={['fas', 'check-double']} size="lg" />,
            isAccessible: routingMenu.accessibleScreens.includes('stock verification') || routingMenu.isLibraryAdmin

        },
        {
            name: "Resource Category",
            url: '/resourcecategory',
            activeScreen: 'resourceCategory',
            icon: <FontAwesomeIcon icon={['fas', 'object-group']} size="lg" />,
            isAccessible: routingMenu.accessibleScreens.includes('resource category') || routingMenu.isLibraryAdmin

        },
        {
            name: "Resource Location",
            url: '/resourcelocation',
            activeScreen: 'resourceLocation',
            icon: <FontAwesomeIcon icon={['fas', 'map-marker']} size="lg" />,
            isAccessible: routingMenu.accessibleScreens.includes('resource location') || routingMenu.isLibraryAdmin

        },
        {
            name: "Resource Requisition",
            url: '/requisition',
            activeScreen: 'resourceRequisition',
            icon: <img style={{ height: "17px" }} src={Requisition} />,
            isAccessible: routingMenu.accessibleScreens.includes('resource requisition') || routingMenu.isLibraryAdmin

        },
        {
            name: "Purchase Request",
            url: '/purchaserequest',
            activeScreen: 'purchaseRequest',
            icon: <FontAwesomeIcon icon={['fas', 'shopping-cart']} size="lg" />,
            isAccessible: routingMenu.accessibleScreens.includes('purchase request') || routingMenu.isLibraryAdmin

        },
        {
            name: "Reports",
            url: '/reports/allReports',
            activeScreen: 'reports',
            icon: <FontAwesomeIcon icon={['fas', 'file-signature']} size="lg" />,
            isAccessible: routingMenu.accessibleScreens.includes('reports') || routingMenu.isLibraryAdmin

        },
        {
            name: "Membership",
            url: '/membership',
            activeScreen: 'membership',
            icon: <FontAwesomeIcon icon={['fas', 'id-card']} size="lg" />,
            isAccessible: routingMenu.accessibleScreens.includes('membership') || routingMenu.isLibraryAdmin

        },
        {
            name: "Invoice",
            url: '/invoice',
            activeScreen: 'invoice',
            icon: <FontAwesomeIcon icon={['fas', 'file-invoice']} size="lg" />,
            isAccessible: routingMenu.accessibleScreens.includes('invoice') || routingMenu.isLibraryAdmin

        },
        {
            name: "No Due Certificates",
            url: '/noDueCertificate',
            activeScreen: 'noDueCertificate',
            icon: <FontAwesomeIcon icon={['fas', 'id-card']} size="lg" />,
            isAccessible: routingMenu.accessibleScreens.includes('noDueCertificate') || routingMenu.isLibraryAdmin

        },
        {
            name: "Library Integration",
            url: '/libraryIntegration',
            activeScreen: 'libraryIntegration',
            icon: <FontAwesomeIcon icon={['fas', 'fingerprint']} size="lg" />,
            isAccessible: true
        },
        {
            name: "Settings",
            url: '/settings',
            activeScreen: 'settings',
            icon: <FontAwesomeIcon icon={['fas', 'cog']} size="lg" />,
            isAccessible: routingMenu.accessibleScreens.includes('setting') || routingMenu.isLibraryAdmin
        }

    ];

    const userNavScreens = [
        {
            name: "User Dashboard",
            url: `/`,
            activeScreen: 'userDashboard',
            icon: <img style={{ height: "17px" }} src={Dashboard} />,
            isAccessible: true
        },
        {
            name: "Resources",
            url: '/user/resource/'+Base64.encode("All"),
            activeScreen: 'userResources',
            icon: <img style={{ height: "17px" }} src={resource} />,
            isAccessible: true
        },
        {
            name: "e-Resources",
            url: '/user/eresoures',
            activeScreen: 'userEresources',
            icon: <img style={{ height: "17px" }} src={Eresources} />,
            isAccessible: true
        },
        {
            name: "Periodicals",
            url: '/user/periodicals',
            activeScreen: 'userPeriodicals',
            icon: <img style={{ height: "17px" }} src={Periodicals} />,
            isAccessible: true
        },
        {
            name: "Rules",
            url: '/user/rules',
            activeScreen: 'userRules',
            icon: <img style={{ height: "17px" }} src={Rules} />,
            isAccessible: true
        },
        {
            name: "Issued Resources",
            url: '/user/issuedresources',
            activeScreen: 'UserIssuedResources',
            icon: <img style={{ height: "17px" }} src={issuereturn} />,
            isAccessible: true
        },
        {
            name: "Requisition",
            url: '/user/requisition',
            activeScreen: 'UserRequisition',
            icon: <img style={{ height: "17px" }} src={Requisition} />,
            isAccessible: true
        },
        {
            name: "Reserve A Book",
            url: '/user/reserveABook',
            activeScreen: 'reserveABook',
            icon: <FontAwesomeIcon icon={['fas', 'clipboard-check']} size="lg" />,
            isAccessible: true
        },
    ]

    // if (config.account === 'faculty') {
    //     userNavScreens.push({
    //         name: "Requisition",
    //         url: '/user/requisition',
    //         activeScreen: 'UserRequisition',
    //         icon: <img style={{ height: "17px" }} src={Requisition} />,
    //         isAccessible: true
    //     });
    // }

    return (
        <>
            <div className={routingMenu.expandRouteMenu ? "routingMenuExpanded" : 'routingMenu'}>
                <div className="routing-menu" id="routing-menu" onMouseOver={() => dispatch({ type: 'TOGGLE_ROUTE_MENU', toggleFlag: true })} onMouseLeave={() => dispatch({ type: 'TOGGLE_ROUTE_MENU', toggleFlag: false })}>
                    {
                        ((routingMenu.IsAdminView == true) ? navScreens : userNavScreens).map((menu, index) => {
                            if (routingMenu.expandRouteMenu) {
                                if (menu.url.includes('.php')) {
                                    if (menu.isAccessible) {
                                        return (
                                            <a href={config.RootUrl + menu.url} style={{ textDecoration: 'none' }}>
                                                <span className={(props.activeScreen == menu.activeScreen) ? "dropdown-item sideMenu-item-name selected" : "dropdown-item sideMenu-item-name"} title={`Click here to view ${menu.name}`} onClick={() => (menu.activeScreen == 'setting') && (typeof props.closeSettingLinks == 'function' && props.closeSettingLinks())}>
                                                    <p className="routeMenuIcon">{menu.icon}</p>
                                                    <p className="routeMenuName">{menu.name}</p>
                                                </span>
                                            </a>
                                        );
                                    }
                                } else {
                                    if (menu.isAccessible) {
                                        return (
                                            <NavLink to={menu.url} style={{ textDecoration: 'none' }}>
                                                <span className={(props.activeScreen == menu.activeScreen) ? "dropdown-item sideMenu-item-name selected" : "dropdown-item sideMenu-item-name"} title={`Click here to view ${menu.name}`} onClick={() => (menu.activeScreen == 'setting') && (typeof props.closeSettingLinks == 'function' && props.closeSettingLinks())}>
                                                    <p className="routeMenuIcon">{menu.icon}</p>
                                                    <p className="routeMenuName">{menu.name}</p>
                                                </span>
                                            </NavLink>
                                        );
                                    }
                                }
                            } else {
                                if (menu.url.includes('.php')) {
                                    if (menu.isAccessible) {
                                        return (
                                            <a href={config.RootUrl + menu.url} style={{ textDecoration: 'none' }}>
                                                <span className={(props.activeScreen == menu.activeScreen) ? "dropdown-item sideMenu-item selected" : "dropdown-item sideMenu-item "} title={`Click here to view ${menu.name}`} onClick={(e) => (menu.activeScreen == 'setting') && (typeof props.closeSettingLinks == 'function' && props.closeSettingLinks())}>
                                                    {menu.icon}
                                                </span>
                                            </a>
                                        );
                                    }
                                } else {
                                    if (menu.isAccessible) {
                                        return (
                                            <NavLink to={menu.url} style={{ textDecoration: 'none' }}>
                                                <span className={(props.activeScreen == menu.activeScreen) ? "dropdown-item sideMenu-item selected" : "dropdown-item sideMenu-item "} title={`Click here to view ${menu.name}`} onClick={(e) => (menu.activeScreen == 'setting') && (typeof props.closeSettingLinks == 'function' && props.closeSettingLinks())}>
                                                    {menu.icon}
                                                </span>
                                            </NavLink>
                                        );
                                    }
                                }
                            }
                        })
                    }
                </div>
            </div>
            <div className="dropdown settingMenu col-md-12">
                <p className="menuDropdownButton dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <FontAwesomeIcon icon={['fas', 'bars']} />
                </p>
                <div className="dropdown-menu setting-dropdown-menu" aria-labelledby="dropdownMenuButton">
                    {
                        ((routingMenu.accessDetails == "true") ? navScreens : userNavScreens).map((menu, index) => {
                            if (menu.url.includes('.php')) {
                                return (
                                    <a href={config.RootUrl + menu.url} style={{ textDecoration: 'none' }}>
                                        <span className={props.activeScreen == menu.activeScreen ? "dropdown-item sideMenu-item-name selected" : "dropdown-item sideMenu-item-name"} title={`Click here to view ${menu.name}`} onClick={() => { setActiveScreen(menu.activeScreen); if (typeof props.closeSettingLinks == 'function') { props.closeSettingLinks() } }}>
                                            <p className="routeMenuIcon">{menu.icon}</p>
                                            <p className="routeMenuName">{menu.name}</p>
                                        </span>
                                    </a>
                                );
                            } else {
                                return (
                                    <NavLink to={menu.url} style={{ textDecoration: 'none' }}>
                                        <span className={props.activeScreen == menu.activeScreen ? "dropdown-item sideMenu-item-name selected" : "dropdown-item sideMenu-item-name"} title={`Click here to view ${menu.name}`} onClick={() => { setActiveScreen(menu.activeScreen); if (typeof props.closeSettingLinks == 'function') { props.closeSettingLinks() } }}>
                                            <p className="routeMenuIcon">{menu.icon}</p>
                                            <p className="routeMenuName">{menu.name}</p>
                                        </span>
                                    </NavLink>
                                );
                            }
                        })
                    }
                </div>
            </div>
        </>
    );
}

export default RoutingMenu;
